var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.1667H12.5M14.1667 17.5001H5.83333C3.99238 17.5001 2.5 16.0076 2.5 14.1667V8.92305C2.5 7.75744 3.10884 6.67651 4.10566 6.07238L8.27233 3.54713C9.33425 2.90356 10.6658 2.90356 11.7277 3.54713L15.8943 6.07238C16.8912 6.67651 17.5 7.75744 17.5 8.92305V14.1667C17.5 16.0076 16.0076 17.5001 14.1667 17.5001Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.90683a3a8c9942e6ca4637f589c56f36.svg";
export { ForwardRef as ReactComponent };